import { GalleryItemData } from '../../lib/types/data/gallery-item-data';
import styles from '../../styles/GalleryItem.module.css';

interface GalleryItemProps {
  data: GalleryItemData;
  onClick?: () => void;
  className?: string;
}

export default function GalleryItem({
  data: { src, alt, title, description },
  onClick,
  className,
}: GalleryItemProps) {
  if (title && description) {
    return (
      <div className={className} onClick={onClick}>
        <img src={src} className={styles.boxItemImage} alt={alt} />
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{description}</p>
      </div>
    );
  }

  return (
    <img
      onClick={onClick}
      src={src}
      className={`${styles.boxItemImageFull} ${className}`}
      alt={alt}
    />
  );
}
